import { createContext } from 'react';

import { Profile } from 'types';

export const UserContext = createContext<Profile>({} as Profile);
